import { render, staticRenderFns } from "./CategoryButtons.vue?vue&type=template&id=e869024e&"
import script from "./CategoryButtons.vue?vue&type=script&lang=ts&"
export * from "./CategoryButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports